<template>
  <de-layout-content>
    <!-- <el-card class="box-card"> -->
    <div
      class="operationPermissions"
      style="display: flex; align-items: center"
    >
      <span>数据操作权限</span>
      <div>
        <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
      </div>
    </div>
    <div class="cell">
      <div class="cellLeft">
        <a-collapse v-model="activeKey" :bordered="true">
          <template #expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel key="1" header="用户角色">
            <div
              :class="['label', index == selectIndex ? 'active' : '']"
              v-for="(item, index) in cellList"
              :key="index"
              @click="selectItem(item, index)"
            >
              {{ item.name }}
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
      <div class="cellRight">
        <div class=""><el-button type="primary" @click="saveData">保存</el-button></div>
        <div class="list" v-for="(value,key,index) in list" :key="key">
          <div class="listHeader">
            <div>{{ key }}</div>
            <div>
              <el-checkbox
                v-model="subList[key]"
                @change="e => handleCheckAllChange(e,key)"
                >全选</el-checkbox
              >
            </div>
          </div>
          <div class="table">
            <el-table
              ref="multipleTable"
              :data="value"
              tooltip-effect="dark"
              style="width: 100%"
              border
            >
              <el-table-column label="分类名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.showName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作权限">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.view" @change="viewRowChange($event,key,scope.$index)">查看</el-checkbox>
                  <el-checkbox v-model="scope.row.add" @change="addRowChange($event,key,scope.$index)">操作</el-checkbox>
                  <!-- <el-checkbox-group
                    v-model="scope.row.checkedList"
                    @change="
                      handleCheckedCitiesChange(
                        scope.row,
                        scope.$index,
                        item,
                        index
                      )
                    "
                  >
                    <el-checkbox
                      v-for="city in scope.row.cities"
                      :label="city"
                      :key="city"
                      >{{ city | filterType }}</el-checkbox
                    >
                  </el-checkbox-group> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- </el-card> -->
  </de-layout-content>
</template>

<script>
import * as API_Member from "@/api/member/member";
import { forEach } from "jszip";
import { log } from '@antv/g2plot/lib/utils';
import { CLOSING } from "sockjs-client";
export default {
  data() {
    return {
      activeKey: ["1"],
      isIndeterminate: true,
      checkAll: false,
      ismenu: false,
      selectIndex: 1,
      type: 2, // 运动员
      selectParamsArr: [],
      cellList: [
        {
          name: "教练员",
          type: 3,
        },
        {
          name: "运动员",
          type: 2,
        },
        {
          name: "队伍管理人员",
          type: 5,
        },
        {
          name: "科研医疗人员",
          type: 4,
        },
      ],
      list: [],
      subList: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      API_Member.findTestProjectMap({
        pageNum: 1,
        pageSize: 10,
        type: this.type,
      }).then((res) => {
        console.log(res.data);
        // let checkedCount = 0;
        // let citiesCount = 0;
        // res.data.forEach((item, index) => {
        //   console.log('item')
        //   console.log(item)
        //   // item.checkedCount = 0;
        //   // item.citiesCount = 0;
        //   // console.log(item.checkedCount, "item.checkedCount");
        //   // console.log(item.citiesCount, "item.citiesCount");
        //   // item.isIndeterminate = item.checkedCount =
        //   //   item.checkedCount > 0 && item.checkedCount < item.citiesCount;
        //   // item.list.forEach((childItem, childIndex) => {
        //   //   childItem.checkedList = childItem.auth
        //   //     ? childItem.auth.split(",")
        //   //     : [];
        //   //   childItem.cities = ["add", "view"];
        //   //   item.checkedCount =
        //   //     childItem.checkedList.length + item.checkedCount;
        //   //   item.citiesCount = childItem.cities.length + item.citiesCount;
        //   //   item.checkAll = item.checkedCount === item.citiesCount;
        //   // });
        //   // console.log(item.checkedCount,'item.checkedCount');
        //   // console.log(item.citiesCount, 'item.citiesCount');
        //   // console.log(item.checkAll, "item.checkAll");
        // });
      // this.$nextTick(() => {
        for (const key in res.data) {
          // this.subList[key] = false
          this.$set(this.subList, key, false);
          let ct = 0
          let list = res.data[key]
          for (let i = 0; i < list.length; i++) {
            const ele = list[i];
            // console.log(ele);
            ele.add = ele.auth&&ele.auth.indexOf('add') > -1
            ele.view = ele.auth&&ele.auth.indexOf('view') > -1
            if(ele.add && ele.view) ct++
          }
          if(ct == list.length) this.subList[key] = true
        }
        // console.log(this.subList);
        
        this.list = res.data;
        // console.log(this.subList);
      // })
        // this.$forceUpdate()
        // this.checkAll = checkedCount === citiesCount;
        // this.isIndeterminate = checkedCount > 0 && checkedCount < citiesCount;
      });
      // this.$axios.post('/sys/project/findTestProjectMap', params).then(res => {
      //   if (res.code == 200) {
      //   }
      // })
    },
    viewRowChange(val,key,index) {
      // console.log(val);
      // console.log(key);
      // console.log(index);
      // this.$set(this.list[key][index],'view',val)
      let list = this.list[key]
      let count = 0
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        if(ele.add && ele.view) count ++
      }
      // console.log(count);
      if(count == list.length) {
        this.subList[key] = true
      } else {
        this.subList[key] = false
      }
      this.$forceUpdate()
    },
    addRowChange(val,key,index) {
      // console.log(val);
      // console.log(key);
      // console.log(index);
      // this.$set(this.list[key][index],'add',val)
      let list = this.list[key]
      let count = 0
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        if(ele.add && ele.view) count ++
      }
      // console.log(count);
      if(count == list.length) {
        this.subList[key] = true
      } else {
        this.subList[key] = false
      }
      this.$forceUpdate()
    },
    handleCheckAllChange(e,key) {
      // console.log(e);
      // console.log(key);
      // console.log(this.subList[key]);
      // let val = this.subList[key]
      this.$set(this.subList, key, e)
      // console.log(val);
      let list = this.list[key]
      // console.log(list);
      for (let i = 0; i < list.length; i++) {
        this.$set(this.list[key][i], 'add', e)
        this.$set(this.list[key][i], 'view', e)
      }
      console.log(this.subList);
      // let cityOptions = this.list[index].list;
      // console.log(cityOptions);
      // cityOptions.forEach((item, index) => {
      //   item.checkedList = val.checkAll ? item.cities : [];
      // });
      // this.list[index].isIndeterminate = false;
      // let arr = this.list[index].list.map((item, index) => {
      //   return {
      //     auth: item.checkedList ? item.checkedList.join(",") : "",
      //     dataFieldId: item.id,
      //   };
      // });
      // let filterArr = arr.filter((item, index) => {
      //   return item.auth;
      // });
      // // console.log(arr, "arr");
      // console.log(filterArr, "filterArr");
      // API_Member.fieldSetAuth({
      //   type: this.type,
      //   list: filterArr,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message.success("操作成功");
      //     // this.getList()
      //   }
      // });
      /////////////// 整页面 ////////////////
      // let cityOptions = this.list;
      // cityOptions.forEach((item, index) => {
      //   item.list.forEach((childItem, childIndex) => {
      //     childItem.checkedList = val ? childItem.cities : [];
      //   });
      // });
      // this.isIndeterminate = false;
      // let arr = [];
      // this.list.forEach((item, index) => {
      //   item.list.forEach((childItem, childIndex) => {
      //     if (childItem.checkedList.length) {
      //       arr.push(childItem);
      //     }
      //   });
      // });
      // let filterArr = arr.map((item, index) => {
      //   return {
      //     auth: item.checkedList ? item.checkedList.join(",") : "",
      //     dataFieldId: item.id,
      //   };
      // });
      // API_Member.fieldSetAuth({
      //   type: this.type,
      //   list: filterArr,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message.success("操作成功");
      //     this.getList();
      //   }
      // });
      // console.log(filterArr);
    },
    handleCheckedCitiesChange(value, index, fatherItem, fatherIndex) {
      console.log(value, index, fatherItem, fatherIndex);
      // this.list[fatherIndex].forEach((item,index) => {
      //   console.log(item);
      // })
      // let params = {
      //   auth: value.checkedList ? value.checkedList.join(",") : "",
      //   dataFieldId: value.id,
      //   type: this.type,
      // };
      // console.log(params);
      // let arr = this.list[fatherIndex].list.map((item, index) => {
      //   return {
      //     auth: item.checkedList ? item.checkedList.join(",") : "",
      //     dataFieldId: item.id,
      //   };
      // });
      // let filterArr = arr.filter((item, index) => {
      //   return item.auth;
      // });
      // console.log(arr, "arr");
      // console.log(filterArr, "filterArr");
      // API_Member.fieldSetAuth({
      //   type: this.type,
      //   list: filterArr,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message.success("操作成功");
      //     // this.getList()
      //   }
      // });

      let checkedCount = 0;
      let citiesCount = 0;
      this.list[fatherIndex].list.forEach((item, index) => {
        checkedCount = item.checkedList.length + checkedCount;
        citiesCount = item.cities.length + citiesCount;
      });
      console.log(checkedCount, 'checkedCount');
      console.log(citiesCount, 'citiesCount');
      this.$set(
        this.list[fatherIndex],
        "checkAll",
        checkedCount === citiesCount
      );
      
      this.$set(
        this.list[fatherIndex],
        "isIndeterminate",
        (checkedCount = checkedCount > 0 && checkedCount < citiesCount)
      );
      console.log(this.list, "this.list");
      

      /////////////// 整页面 ////////////////
      // let arr = [];
      // this.list.forEach((item, index) => {
      //   item.list.forEach((childItem, childIndex) => {
      //     if (childItem.checkedList.length) {
      //       arr.push(childItem);
      //     }
      //   });
      // });
      // let filterArr = arr.map((item, index) => {
      //   return {
      //     auth: item.checkedList ? item.checkedList.join(",") : "",
      //     dataFieldId: item.id,
      //   };
      // });
      // console.log(filterArr);
      // API_Member.fieldSetAuth({
      //   type: this.type,
      //   list: filterArr,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message.success("操作成功");
      //     this.getList();
      //   }
      // });
    },
    selectItem(item, index) {
      this.selectIndex = index;
      this.type = item.type;
      this.getList();
    },
    saveData() {
      let arr = [];
      for (const key in this.list) {
        let list = this.list[key]
        for (let i = 0; i < list.length; i++) {
          const ele = list[i];
          console.log(ele);
          if(ele.add || ele.view) {
            arr.push({
              auth: ele.add && ele.view ? 'add,view' : ele.add ? 'add' : 'view',
              type: this.type,
              dataFieldId: ele.id
            })
          }
        }
      }
      console.log(arr);
      API_Member.fieldSetAuth({
        type: this.type,
        list: arr,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.$message.success("操作成功");
          this.getList();
        }
      });
      // this.list.forEach((item, index) => {
      //   item.list.forEach((childItem, childIndex) => {
      //     if (childItem.checkedList.length) {
      //       arr.push(childItem);
      //     }
      //   });
      // });
      // let filterArr = arr.map((item, index) => {
      //   return {
      //     auth: item.checkedList ? item.checkedList.join(",") : "",
      //     dataFieldId: item.id,
      //   };
      // });
      // console.log(filterArr,'filterArr');
      // API_Member.fieldSetAuth({
      //   type: this.type,
      //   list: filterArr,
      // }).then((res) => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     this.$message.success("操作成功");
      //     this.getList();
      //   }
      // });
    }
  },

  filters: {
    filterType(val) {
      let str = "";
      if (val == "add") {
        str = "添加";
      } else {
        str = "查看";
      }
      return str;
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  .listHeader {
    height: 50px;
    margin-top:20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 15px;
    font-size: 14px;
    color: #fff;
  }
}

.cell {
  display: flex;

  .cellLeft {
    width: 240px;

    // border: 1px solid #f2f2f2;
    .ant-collapse {
      background-color: #21284b;
      border: 1px solid rgba(255, 255, 255, 0.1);
    }
  }

  .cellRight {
    flex: 1;
    min-width: 0;
    padding: 0 22px;
  }
}

::v-deep.ant-collapse {
  border-radius: 0 !important;
  color: #fff;
}

::v-deep.ant-collapse > .ant-collapse-item {
  border-bottom: 0 !important;
}

::v-deep.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  color: rgba(255, 255, 255, 0.5);
  font-weight: bold;
}

::v-deep.ant-collapse > .ant-collapse-item:last-child,
.ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0 !important;
}

.label {
  padding: 0 16px;
  height: 52px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

::v-deep.ant-collapse-item:last-child > .ant-collapse-content {
  border-radius: 0 !important;
}

::v-deep.ant-collapse-content {
  background-color: #21284b;
  color: #fff;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.ant-collapse-content-box {
  .label {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    &:hover {
      background-color: rgba(24, 144, 255, 0.5);
      color: #fff;
    }
  }
  .label:last-child {
    border-bottom: 0;
  }

  .active {
    background-color: rgba(24, 144, 255, 1);
  }
}

::v-deep.ant-collapse-content-box {
  padding: 0;
}

.operationPermissions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;

  & > span {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }

  .cellRight {
    .el-table {
      border: 1px solid #21284b;
    }
  }
}
</style>
